import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { useSearchParams } from "react-router-dom";

const PersistSearch = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchkey = searchParams.get("searchkey") || "";
  const [searchText, setSearchText] = useState(searchkey);

  React.useEffect(() => {
    setSearchText(searchkey);
  }, [searchkey]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    const newParams = new URLSearchParams(searchParams);
    setSearchText(value);

    if (value === "") {
      newParams.delete("searchkey");
      newParams.set("page", "1");
      setSearchParams(newParams);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const newParams = new URLSearchParams(searchParams);

      if (searchText.trim()) {
        newParams.set("searchkey", searchText.trim());
      } else {
        newParams.delete("searchkey");
      }

      newParams.set("page", "1");
      setSearchParams(newParams);
    }
  };

  return (
    <div className="user-pro-search">
      <Form.Control
        type="search"
        placeholder="Search"
        className="form-control"
        value={searchText}
        onChange={handleSearchChange}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

export default PersistSearch;
